// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__nUrec","loader_fullScreen":"styles_loader_full-screen__4EV2n"};